module.exports = __webpack_public_path__ + "static/media/work.febe8495.svg";